
export default {
    name: "ProgressBar",
    props: {
        progression: {
            type: Number,
            default: 0
        }
    },
    computed: {
        getStyle() {
            return {
                "--progression": `${this.progression}%`
            };
        }
    }
};
